import LoginDTO from "../shared/dtos/loginDTO";
import PATHS from "./paths";
import axiosInstance from "../app/axios";

export const adminLogin = async (credentials: LoginDTO) => {
  credentials.client_id = process.env.REACT_APP_ADMIN_CLIENT_ID;
  credentials.client_secret = process.env.REACT_APP_ADMIN_CLIENT_SECRET;
  credentials.device_type = process.env.REACT_APP_ADMIN_DEVICE_TYPE;
  credentials.device_token = process.env.REACT_APP_ADMIN_DEVICE_TOKEN;
  credentials.grant_type = process.env.REACT_APP_GRANT_TYPE;

  const result = await axiosInstance.post(`${PATHS.AUTH_ADMIN}`, credentials);

  return result.data;
};

export const adminPasswordReset = async (newPassword: string) => {
  const result = await axiosInstance.patch(`${PATHS.ADMIN_PASSWORD_RESET}`, {
    newPassword: newPassword,
  });

  return result;
};

export const sendUserRecoveryCode = async (email: string) => {
  const result = await axiosInstance.post(`${PATHS.FORGOT_PASSWORD_USER}`, {
    email,
  });

  return result;
};

export const recoverUserPassword = async (
  email: string,
  codeRecovery: string,
  password: string,
) => {
  const result = await axiosInstance.post(`${PATHS.RECOVER_PASSWORD_USER}`, {
    email,
    codeRecovery,
    password,
  });

  return result;
};
